import React from 'react';
import { Endpoints } from 'app-constants';
import { Typography, Link } from '@material-ui/core';

const CopyRight = () => (
  <Typography variant="subtitle1" color="textSecondary" align="center">
    {'Copyright © '}
    <Link color="inherit" href={Endpoints.FACEBOOK_PAGE}>
      Artistic Home
    </Link>
    {` ${new Date().getFullYear()}`}
  </Typography>
);

export default CopyRight;
